const eventDetails = {
    init() {
        eventDetails.create();
    },
    create() {
        const boxEffect = $(".box.w-text-effect");
        if (!boxEffect.length) return;

        let box_title_height = 0;
        let box_space_top = 0;
        let box_space_bottom = 0;
        let box_height = 0;
        let translateY = 0;

        checkBoxEffect();
        setTimeout(function() {
            checkBoxEffect();
        }, 1000)
        $(window).resize(function(event) {
            checkBoxEffect();
        });

        function checkBoxEffect() {
            boxEffect.each(function(index, el) {
                const $this = $(this);

                box_title_height = $this.find('[data-title]').outerHeight(true);
                box_space_top = parseInt($this.css('padding-top'));
                box_space_bottom = $(window).width() >= 1280 ? 60 : 40;
                box_height = $this.outerHeight(true);
                translateY = box_height - box_title_height - box_space_top - box_space_bottom;

                $this.css('transform', 'translateY('+ translateY + 'px)');

            });
        }
    }
};

$(function() {
    eventDetails.init();

    $('.panel-event-details [data-speakers-title]').matchHeight({
        byRow: false,
        property: 'height',
        target: null,
        remove: false
    });

    $('.panel-event-details [data-speakers-sub-title]').matchHeight({
        byRow: false,
        property: 'height',
        target: null,
        remove: false
    });
});